const $inject = ['$location', '$rootScope', '$q', '$http', '$filter', '$interval', '$document', 'Upload', 'authService', 'dataService'];

const lbaHotelCtrl = function ($location, $rootScope, $q, $http, $filter, $interval, $document, Upload, authService, dataService) {
  let vm = this;
  
  vm.tab = 'iata';
  vm.hotelTags = [];

  vm.page = 1;
  vm.pageSize = 50;
  vm.hasNextPage = false;

  vm.hotelDownloadSettings = {
    displayName: 'Download Hotels Data',
    fileNameSuffix: 'Hotels.xlsx',
    endPointController: 'Hotels'
  };

  vm.fileUploadState = { success: null, error: null, uploading: null };
  vm.isBulkChangeAdmin = authService.getIsBulkChangeAdmin();

  vm.showDisabledHotels = false;
  vm.updateHotelsList = updateHotelsList;

  vm.getHotels = getHotels;
  vm.refreshIATA = refreshIATA;
  vm.searchByIata = searchByIata;
  vm.searchByHotelName = searchByHotelName;
  vm.searchByHotelId = searchByHotelId;
  vm.searchByHotelTags = searchByHotelTags;

  vm.showEditModal = showEditModal;
  vm.editHotel = editHotel;
  vm.addIdentifier = addIdentifier;
  vm.removeIdentifier = removeIdentifier;
  vm.upload = upload;

  vm.currentHotelSource = null;
  vm.editHotelIdentifiersHasError = false;
  vm.editHotelErrorMessage = null;
  vm.changeTab = changeTab;
  vm.updatePage = updatePage;

  function updateHotelsList(resetPage = true) {
    if (resetPage) {
      vm.page = 1;
    }

    switch (vm.tab) {
      case 'iata':
        return vm.searchByIata();
      case 'name':
        return vm.searchByHotelName();
      case 'id':
        return vm.searchByHotelId();
      case 'tags':
        return vm.searchByHotelTags();
      default:
        return vm.getHotels();
    }
  }

  function showEditModal(hotel) {
    if (!hotel.showEditModal) {
      vm.currentHotelSource = hotel;
      vm.currentHotel = angular.copy(hotel);
      hotel.showEditModal = true; 
    } else {
      vm.currentHotelSource = null;
      vm.currentHotel = null;
      hotel.showEditModal = false;
    }

    vm.editHotelErrorMessage = null;
    setBodyScrollLock();
  }

  function setBodyScrollLock() {
    const hasOpenModal = (vm.hotels || []).some((hotel) => hotel.showEditModal);
    $document[0].body.classList.toggle('lba-modal-open', hasOpenModal);
  }

  function buildHotelsQuery(filterQuery) {
    const skip = (vm.page - 1) * vm.pageSize;
    const filters = [];

    if (!vm.showDisabledHotels) {
      filters.push('IsDeleted+eq+(false)');
    } else {
      filters.push('(IsDeleted+eq+(true)+or+IsDeleted+eq+(false))');
    }

    if (filterQuery) {
      filters.push(filterQuery);
    }

    const filterPart = filters.length
      ? `$filter=${filters.join('+and+')}&`
      : '';

    // Request one extra row so we know whether a next page exists.
    return `Hotels?${filterPart}$orderby=Name+asc&$top=${vm.pageSize + 1}&$skip=${skip}`;
  }

  function getPagedHotels(filterQuery, type) {
    return getData(buildHotelsQuery(filterQuery), type)
      .then((data) => {
        if (!data) {
          return;
        }

        vm.loading = false;

        vm.hasNextPage = data.length > vm.pageSize;
        vm.hotels = data.slice(0, vm.pageSize);
      });
  }

  function getHotels() {
    return getPagedHotels(null, 'Hotels list');
  }

  function searchByIata() {
    if (!vm.IATA || !vm.IATA.Iata) {
      return getHotels();
    }

    return getPagedHotels(
      getStringContainsQueryParameter('AirportCode', vm.IATA.Iata),
      'Hotel by IATA search'
    );
  }

  function refreshIATA(searchText) {
    if (searchText.length > 2) {
        let query = `Airports?$filter=IsDeleted+eq+(false)+and+`
          + `(${getStringContainsQueryParameter('Iata', searchText)}`
          + `+or+${getStringContainsQueryParameter('Name', searchText)}`
          + `+or+${getStringContainsQueryParameter('City', searchText)})`;
        
        getData(query, "IATA search")
          .then((data) => {
            if (data) {
              vm.resultsIATA = data;
            }
          });
    }
  }

  function searchByHotelName() {
    if (!vm.hotelNameSearchText || vm.hotelNameSearchText.length <= 2) {
      return getHotels();
    }

    return getPagedHotels(
      getStringContainsQueryParameter('Name', vm.hotelNameSearchText),
      'Hotel Name search'
    );
  }

  function searchByHotelId() {
    if (!vm.hotelIdSearchText) {
      return getHotels();
    }

    return getPagedHotels(
      getObjectListContainsExactValueQueryParameter('Identifiers', vm.hotelIdSearchText),
      'Hotel Id search'
    );
  }

  function searchByHotelTags() {
    if (!vm.hotelTagsSearch || vm.hotelTagsSearch.length === 0) {
      return getHotels();
    }

    var filterQuery = '';
    for (let i = 0; i < vm.hotelTagsSearch.length; i++) {
      if (i != 0) {
        filterQuery += '+and+';
      }

      filterQuery += `${getListContainsExactValueQueryParameter('Tags', vm.hotelTagsSearch[i])}`
    }

    let query = `Hotels?$filter=${vm.showDisabledHotels ? "(IsDeleted+eq+(true)+or+IsDeleted+eq+(false))+and+" : "IsDeleted+eq+(false)+and+"}`
      + filterQuery;

    getData(query, "Hotel Id search")
      .then((data) => {
        if (data) {
          vm.hotels = data;
          vm.page = 1;
          vm.numberOfPages = getNumberOfPages();
        }
      });

    return getPagedHotels(
      filterQuery,
      'Hotel tags search'
    );
  }

  function getData(query, type) {
    let deferred = $q.defer();
    vm.loading = true;
    dataService.get(query)
      .then((data) => {
        if (!data) {
          throw new Error('Empty response or no response returned.');
        }

        deferred.resolve(data);
      })
      .catch((error) => {
        console.log(`${type} failed: `, error);
        vm.loading = false;
        $rootScope.$broadcast('lbaLoader:loaderState', { state: false, text: '' });
        deferred.resolve(null);
      });

    return deferred.promise;
  }

  function updateData(query, type, hotel) {
    let deferred = $q.defer();
    dataService.patch("Hotels", hotel, hotel.Id, true)
      .then((data) => {
        deferred.resolve(data);
      })
      .catch((error) => {
        console.log(`${type} failed: `, error);
        vm.loading = false;
        deferred.reject(error);
      });

    return deferred.promise;
  }

  function editHotel(form, hotel) {
    clearErrors(form);

    const payload = angular.copy(hotel);
    delete payload.showEditModal;

    updateData("Hotels", "Hotel update", payload)
      .then((data) => {       
        if (vm.currentHotelSource) {
          angular.extend(vm.currentHotelSource, payload);
          vm.currentHotelSource.showEditModal = false;
        }

        vm.currentHotelSource = null;
        vm.currentHotel = null;
        setBodyScrollLock();
      })
      .catch((error) => {
        if (error.error && error.error.message) {
          vm.editHotelErrorMessage = error.error.message;
          var errors = error.error.message.split(',');
          errors.forEach((err) => {
            if (err.includes('Description')) {
              setFieldServerError(form, 'editHotelDescription', err);
            }
            else if (err.includes('Name')) {
              setFieldServerError(form, 'editHotelName', err);
            }
            else if (err.includes('Address')) {
              setFieldServerError(form, 'editHotelAddress', err);
            }
            else if (err.includes('City')) {
              setFieldServerError(form, 'editHotelCity', err);
            }
            else if (err.includes('State')) {
              setFieldServerError(form, 'editHotelState', err);
            }
            else if (err.includes('PostalCode')) {
              setFieldServerError(form, 'editHotelPostalCode', err);
            }
            else if (err.includes('CountryCode')) {
              setFieldServerError(form, 'editHotelCountryCode', err);
            }
            else if (err.includes('AirportCode')) {
              setFieldServerError(form, 'editHotelAirportCode', err);
            }
            else if (err.includes('Latitude')) {
              setFieldServerError(form, 'editHotelLatitude', err);
            }
            else if (err.includes('Longitude')) {
              setFieldServerError(form, 'editHotelLongitude', err);
            }
            else if (err.includes('Tag')) {
              setFieldServerError(form, 'editHotelTags', err);
            }
            else if (err.includes('Identifier')) {
              setFieldServerError(form, 'editHotelIdentifiers', err, true);
            }
          });
        } else {
          vm.editHotelErrorMessage = 'Save failed. Please try again.';
        }
      });
  }

  function clearErrors(form) {
    vm.editHotelErrorMessage = null;
    vm.editHotelIdentifiersHasError = false;
    
    [
      'editHotelDescription',
      'editHotelName',
      'editHotelAddress',
      'editHotelCity',
      'editHotelState',
      'editHotelPostalCode',
      'editHotelCountryCode',
      'editHotelAirportCode',
      'editHotelLatitude',
      'editHotelLongitude',
      'editHotelTags',
      'editHotelIdentifiers'
    ].forEach((fieldName) => {
      const formController = form[fieldName];
      if (!formController || !formController.$error) {
        return;
      }

      Object.keys(formController.$error).forEach((errorKey) => {
        formController.$setValidity(errorKey, true);
      });
    });
  }

  function setFieldServerError(form, fieldName, errorKey, isTable = false) {
    if (!isTable) {
      const formController = form[fieldName];
      if (!formController) {
        return;
      }

      formController.$setValidity(errorKey, false);
      formController.$setTouched();
    } else {
      vm.editHotelIdentifiersHasError = true;
    }
  }

  function addIdentifier() {
    if (!vm.currentHotel.Identifiers) {
      vm.currentHotel.Identifiers = [];
    }
    vm.currentHotel.Identifiers.push({ Provider: '', Type: '', Value: '' });
  }

  function removeIdentifier(index) {
    vm.currentHotel.Identifiers.splice(index, 1);
  }

  function upload(file) {
    vm.fileUploadState.uploading = true;

    let fileName = '';
    let fileNameDate = new Date();

    fileName = dateTimeString( fileNameDate.getFullYear() );
    fileName += dateTimeString( fileNameDate.getMonth() + 1);
    fileName += dateTimeString( fileNameDate.getDate() ) + '_';
    fileName += dateTimeString( fileNameDate.getHours() );
    fileName += dateTimeString( fileNameDate.getMinutes() );
    fileName += dateTimeString( fileNameDate.getSeconds() )
      + '_' + file.name.substr(0,file.name.lastIndexOf('.'));
    fileName = fileName.replace(/[^\w\s _]/g,'');

    Upload.upload({
      url: `${endPointUrl}/api/Upload/HotelFileUpload?filename=${fileName}`,
      data: {file: file}
    }).then(function (resp) {
      console.log('SUCCESS resp: ', resp);
      vm.fileUploadState = { success: true, error: null, uploading: false };
    }, function (resp) {
      console.log('ERROR resp: ', resp);
      vm.fileUploadState = { success: null, error: true, uploading: false };
    }, function (evt) {
      console.log('evt: ', evt);
    });
  }

  function changeTab(tabName) {
    vm.tab = tabName;
    updatePage(1);
  }

  function updatePage(index) {
    if (index <= 0 || vm.loading) {
      return false;
    }

    if (index > vm.page && !vm.hasNextPage) {
      return false;
    }

    vm.page = index;
    return vm.updateHotelsList(false);
  }

  //#region Helper Functions

  // TODO: Need to be able to handle quotes. Currently does not work with '.
  function getStringContainsQueryParameter(field, value) {
    // The below does not work.
    //    return `contains(tolower(${field}), tolower('${encodeURIComponent(value.replace(/'/g, "''"))}'))`;
    // The below does not work either.
    let odataEscaped = getODATAEscapedValue(value);
    return encodeURIComponent(`contains(tolower(${field}), tolower('${odataEscaped}'))`);
  }

  // TODO: Need to be able to handle quotes. Currently does not work with '.
  function getObjectListContainsExactValueQueryParameter(field, value) {
    let odataEscaped = getODATAEscapedValue(value);
    return encodeURIComponent(`${field}/any(i: tolower(i/Value) eq tolower('${odataEscaped}'))`);
  }

  // TODO: Need to be able to handle quotes. Currently does not work with '.
  function getListContainsExactValueQueryParameter(field, value) {
    let odataEscaped = getODATAEscapedValue(value);
    return encodeURIComponent(`${field}/any(i: tolower(i) eq tolower('${odataEscaped}'))`);
  }

  function getODATAEscapedValue(value) {
    return value.replace(/'/g, "''");
  }

  function getNumberOfPages() {
    if (vm.hotels) {
      return Math.ceil(vm.hotels.length / vm.pageSize);
    }
    
    return 1;
  }

  function convert(str) {
    return str.replace(/(?:\r\n|\r|\n)/g, '<br />');
  }

  function getNumber(num) {
    return new Array(num);
  }

  function dateTimeString(int){
    if (String(int).length === 1) return '0' + int;

    return String(int);
  }

  //#endregion

  vm.getHotels();
};

lbaHotelCtrl.$inject = $inject;

export default lbaHotelCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaHotel/lbaHotelCtrl.js